import { useSelector, TypedUseSelectorHook } from 'react-redux';

import { RootState } from '../../app/rootReducer';

export const rootSelector: TypedUseSelectorHook<RootState> = useSelector;